import { useTheme } from "@mui/material";
import { CSSProperties, useEffect, useState } from "react";
import { ClusterMenuItem, ClusterSelect } from "./CommunityClusterSelect.styles";
import { ClusterData } from "../../queries/community.types";
import { useCommunityClusterStore, useCurrentCommunityCluster } from "../../stores";
import { Icon } from "../Icon";

export function CommunityClusterSelect({ predicate = () => true, sx }:{ predicate?: (cluster:ClusterData) => boolean, sx?: CSSProperties }) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const { isLoading, availableClusters: clusters, currentCluster } = useCurrentCommunityCluster();
  const { setCurrentCluster } = useCommunityClusterStore();
  useEffect(() => {
    if(predicate && (!currentCluster || !predicate(currentCluster))) {
      setCurrentCluster(clusters.find(predicate));
    }
  }, [predicate, currentCluster, clusters, setCurrentCluster]);
  if(!isLoading && clusters.length>1) {
    return <>
      <ClusterSelect color="info" value={ currentCluster?.id } open={ open } onOpen={ () => setOpen(true) } onClose={ () => setOpen(false) } onChange={ (evt) => {
        const selectedCluster = clusters.find((cluster) => cluster.id === evt.target.value);
        setCurrentCluster(selectedCluster);
      } } IconComponent={ () => <Icon icon="dropdown" size={ 20 } sx={ {
        transition: "all .3s linear",
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        cursor: "pointer"
      } } onClick={ () => setOpen((cur) => !cur) } /> } renderValue={ (value) => {
        const selectedCluster = clusters.find((cluster) => cluster.id === value);
        return <><Icon icon="cluster" size={ 24 } sx={ {
          "marginRight": theme.spacing(2)
        } } />{ selectedCluster?.name }</>;
      } } MenuProps={ {
        PaperProps: {
          sx: (theme) => ({
            marginTop: theme.spacing(1),
            padding: theme.spacing(3),
            background: `${theme.linearGradients.gradientB}!important`
          })
        }
      } } sx={ sx }>
        {
          clusters.filter(predicate).map((cluster) => <ClusterMenuItem value={ cluster.id } key={ cluster.id }><Icon icon="cluster" size={ 24 } sx={ {
            "marginRight": theme.spacing(2)
          } } />{ cluster.name }</ClusterMenuItem>)
        }
      </ClusterSelect>
    </>;
  }
  return <></>;
}


